import { YARA_REPO_UPDATE_DIALOG_TYPES } from "../yara_repositories/consts";

export interface IYaraRepoFormData {
  id?: number;
  name: string;
  url: string;
  source_branch?: string;
  api_token?: string;
  api_token_set: boolean;
  import_update_preferences: number;
  is_custom: boolean;
}

export interface IYaraRepoDataItem extends IYaraRepoFormData {
  user: string | null;
}

export type IYaraRepoResults = IYaraRepoDataItem[];

export interface IYaraRepoListResponse {
  count: number;
  next?: unknown;
  previous?: unknown;
  results: IYaraRepoResults;
}

export type IOnlineSourceSelectionItem = {
  label: string;
  value: string;
};

export interface IOnlineSourceSelectionSections {
  userItems: IOnlineSourceSelectionItem[];
  systemItems: IOnlineSourceSelectionItem[];
}

export type IYaraRepoDialogType =
  | typeof YARA_REPO_UPDATE_DIALOG_TYPES[keyof typeof YARA_REPO_UPDATE_DIALOG_TYPES];

export type IYaraRepoRequestErrors =
  | {
      [key: string]: string[];
    }
  | undefined;

export interface IYaraRepoRequestResponse {
  data: {
    message: string;
  };
}

export interface IYaraRepoRequestErrorResponse {
  errors?: IYaraRepoRequestErrors;
  message: string;
}

export interface IYaraDeleteParams {
  repoId: number | undefined;
  shouldRemoveRulesets: boolean;
}

export interface IYaraDeleteSuccessResponse {
  data: {
    failed_ruleset_removals: {
      name: string;
      reason?: string;
    }[];
  };
}
